import React, { ReactElement, Ref, FC, DetailedHTMLProps, InputHTMLAttributes, forwardRef } from 'react';
import classnames from 'classnames';
import '@eika/input-style';
import { ErrorLabel } from '@eika/label';
import InputLabel from './InputLabel';

declare type BasicInputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export interface InputProps extends BasicInputProps {
    className?: string;
    label?: string;
    sublabel?: string;
    type?: string;
    infoButton?: React.ReactNode;
    error?: boolean | string | ReactElement;
}

const InputError: FC<{ error: string | ReactElement }> = ({ error }) =>
    typeof error === 'string' ? (
        <ErrorLabel aria-live="polite" className="sgw-input__error-label" text={error} />
    ) : (
        <>{error}</>
    );

const Input = forwardRef(
    (
        { label, sublabel, type = 'text', error = false, className, infoButton, ...rest }: InputProps,
        ref: Ref<HTMLInputElement>,
    ): JSX.Element => {
        const inputClassName = !label && !sublabel ? className : '';
        return (
            <InputLabel label={label} sublabel={sublabel} infoButton={infoButton} className={className}>
                <input
                    className={classnames('sgw-input__input', { 'sgw-input__error': !!error }, inputClassName)}
                    aria-invalid={!!error}
                    type={type}
                    ref={ref}
                    {...rest}
                />
                {error && typeof error !== 'boolean' && <InputError error={error} />}
            </InputLabel>
        );
    },
);

export default Input;
